<div class="card-actuation header-actuation m-r-6 m-b-6" *ngIf="DisplayEmployeeView">
    <div class="title-height" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="h3 pr-16 cardHeader">{{CardTitle}}</div>
    </div>
    <div class="inner-card flow-root column">
        <div class="p-10 pt-0 p-b-5">
            <table class="border-none">
                <caption></caption>
                <tr>
                   <th></th>>
                </tr>
                <tr>
                    <td>
                        <span *ngIf="gender !== '' && gender !== null">
                            <span class="f-w-600">{{gender | titlecase }}</span> de
                        </span>
                        <span *ngIf="age !== null && age > 0 ">
                            <span matTooltip="{{birthDate}}" class="f-w-600">{{ age }} años</span> de
                        </span>
                        <span *ngIf="city !== '' && city !== null">
                            <span matTooltipClass="formatted" matTooltip="{{formatedAddress}}">{{city |
                                titlecase}}</span>
                        </span>

                    </td>
                </tr>

                <tr
                    *ngIf="(yearDiffrence !=null  && yearDiffrence > 0 && textFollowedByYear !='') || (textFollowedByMonth != null && textFollowedByMonth != '')">
                    <td>Antigüedad:
                        <span *ngIf="yearDiffrence !=null && textFollowedByYear !='' && yearDiffrence > 0"
                            matTooltipClass="formatted"
                            matTooltip="{{hiringAndContractEndDateToolTip}}">{{yearDiffrence}}
                            {{textFollowedByYear}}</span>

                        <span *ngIf="(yearDiffrence != null && textFollowedByYear !=''  && yearDiffrence > 0) && 
              (monthDiffrence != null && monthDiffrence > 0 && textFollowedByMonth != '')"> y </span>

                        <span matTooltipClass="formatted" matTooltip="{{hiringAndContractEndDateToolTip}}"
                            *ngIf="monthDiffrence != null && monthDiffrence > 0 && textFollowedByMonth != '' ">{{monthDiffrence}}
                            {{textFollowedByMonth}}.</span>
                        <span class="color-red" matTooltipClass="formatted"
                            matTooltip="{{hiringAndContractEndDateToolTip}}">{{BaajaDeeText}}</span>
                    </td>
                </tr>

                <tr>
                    <td>
                        <span matTooltipClass="formatted" matTooltip="{{consentimentoHouverText}}"
                            *ngIf="consentType != null || consent != null">
                            <strong>{{consentToShow}}</strong>
                        </span>
                    </td>
                </tr>

                <tr *ngIf="formatedTelephoneArray !== ''">
                    <td>Tel: {{formatedTelephoneArray}}</td>
                </tr>

                <tr>
                    <td><span *ngIf="puesto !=null"> Puesto: {{ puesto | titlecase}}</span></td>
                </tr>

            </table>
        </div>
    </div>
</div>